import { Component, OnInit } from '@angular/core';
import { ChartOptions } from 'chart.js';
import { BehaviorSubject } from 'rxjs';
import { GraphDataResponse, KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { formatDateHuman } from '../../../ui-components/standard-date.pipe';

@Component({
  selector: 'sa-average-turn-rate',
  styleUrls: ['./average-turn-rate.component.scss'],
  templateUrl: './average-turn-rate.component.html',
})
export class AverageTurnRateComponent implements OnInit {
  public regionID: number;
  public fracsID: number[];
  public carrierID: number;
  public loading = false;
  public timeframe = 30;
  public datasets: GraphDataResponse = this.initializeAverageTurnRate();
  public isNoDataSubject$$ = new BehaviorSubject<boolean>(true);

  public chartColors: any[] = [
    {
      backgroundColor: ['rgb(32,118,135, 0.5)'],
      borderColor: ['rgb(32,118,135)'],
    },
  ];

  public options: ChartOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public ngOnInit(): void {
    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      this.resetAverageTurnRate();
      this.regionID = regionID;
      this.fetchAverageTurnRate();
    });

    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.resetAverageTurnRate();
        this.fracsID = fracsID;
        this.fetchAverageTurnRate();
      }

      if (fracsID.length < 1 && this.regionID) {
        this.resetAverageTurnRate();
        this.fetchAverageTurnRate();
      }
    });

    this.kpiDashboardService.carrierID$.subscribe((carrierID) => {
      if (carrierID >= 0) {
        this.resetAverageTurnRate();
        this.carrierID = carrierID;
        this.fetchAverageTurnRate();
      }
    });
  }

  private fetchAverageTurnRate(): void {
    this.loading = true;
    this.isNoDataSubject$$ = new BehaviorSubject<boolean>(false);
    const averageTurnRateTimeframe = this.kpiDashboardService.getLocalStorage('average_turn_rate_timeframe');
    if (averageTurnRateTimeframe) {
      this.timeframe = averageTurnRateTimeframe;
    }
    this.kpiDashboardService
      .getAverageTurnRate$(this.regionID, this.fracsID, this.carrierID, this.timeframe)
      .subscribe((data) => {
        this.datasets = data;

        this.datasets.labels.map((label, index) => {
          this.datasets.labels[index] = formatDateHuman(label);
        });

        data.datasets.forEach((value) => {
          const sum = value.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          if (value.data.length !== 0 && sum !== 0) {
            this.loading = false;
            this.isNoDataSubject$$?.next(false);
          } else {
            this.isNoDataSubject$$?.next(true);
          }
        });

        this.loading = false;
      });
  }

  private resetAverageTurnRate(): void {
    this.datasets = this.initializeAverageTurnRate();
  }

  private initializeAverageTurnRate(): GraphDataResponse {
    this.isNoDataSubject$$?.next(true);
    return {
      datasets: [
        {
          data: [0],
          label: '',
        },
      ],
      labels: [''],
    };
  }

  public onTimeframeChange(timeframe: number) {
    this.timeframe = timeframe;
    this.kpiDashboardService.setLocalStorage('average_turn_rate_timeframe', this.timeframe);
    this.fetchAverageTurnRate();
  }
}
